import getType from './getType';

export default function isEmpty(value: unknown) {
  switch (getType(value)) {
    case 'Object': {
      return !Object.keys(value as object).length;
    }

    case 'String': {
      return !(value as string).trim().length;
    }

    case 'Null': {
      return true;
    }
  }
}
